export const seniorAdOperationsResume = `
【職務概要】
インターネット広告運用の分野で13年以上のキャリアを積み、特にリスティング広告とディスプレイ広告を中心に幅広い運用経験を持つ。消費財、不動産、アプリ、ECなど多様な業界のクライアントに対するデジタル広告戦略の立案から運用、分析までをワンストップで手掛けてきた。

特に強みとしているのは、大規模予算の広告運用とデータドリブンな意思決定による効果最大化である。広告プラットフォームの急速な変化や技術トレンドを常に追求し、Google広告やMeta広告などの主要媒体に加え、最新のDSP、動画広告、アフィリエイト広告も含めた統合的な広告運用の知見を持つ。近年は生成AIを活用した広告クリエイティブの最適化や、プライバシー規制強化に対応したCookieless時代の計測戦略にも取り組んでいる。

後進の育成にも力を入れており、これまで20名以上のマーケターの成長をサポートしてきた。クライアントビジネスの成功を第一に考え、単なる広告運用にとどまらない事業成長のパートナーとしての役割を担うことを信条としている。

【職務経歴】
・株式会社Algomaticデジタルマーケティング（2018年4月〜現在）
  ○ 会社概要：従業員数約120名、デジタルマーケティングエージェンシー
  ○ 職務内容：シニアアカウントディレクター
   - 月間予算5,000万円〜1億円規模の大手企業10社のデジタル広告運用を統括
   - Google、Meta、Twitter、TikTok等の広告プラットフォーム横断的な統合運用
   - 広告効果を最大化するためのクリエイティブ戦略立案と制作ディレクション
   - デジタル広告運用チーム（8名）のマネジメントとメンバー育成
  ○ 具体的な成果：
   - 大手ECクライアントのROAS改善（前年比30%向上）とCPA削減（25%減）を実現
   - 自動車メーカーの新車発売キャンペーンにおいて、広告経由コンバージョン数を前回比45%向上
   - 広告運用プロセスの標準化により、チーム全体の業務効率を35%改善
   - 機械学習を活用した入札最適化システムの導入により、クライアント全体の平均CPAを18%削減
  ○ 使用した技術・ツール：
   - Google広告、Meta広告、Twitter広告、TikTok広告、LINE広告、各種DSP
   - Google Analytics 4、Adobe Analytics、Tableau、Data Studio
   - MAツール（Marketo、HubSpot）との連携
   - 自社開発のアトリビューション分析ツール

・株式会社Algomaticメディア（2013年5月〜2018年3月）
  ○ 会社概要：従業員数約80名、Web媒体運営とデジタル広告代理業
  ○ 職務内容：アカウントマネージャー
   - 中堅〜大手企業15社のデジタル広告運用を担当
   - 運用型広告を中心とした月間500〜3,000万円規模の広告予算管理
   - クライアントの事業KPIに基づいた広告戦略立案と四半期ごとの戦略提案
   - メディアプランニングからアトリビューション分析までの一貫したプロセス管理
  ○ 具体的な成果：
   - 不動産デベロッパーの広告費効率を改善し、資料請求CPAを42%削減
   - アプリクライアントのインストール単価を30%削減しながら、6ヶ月LTVを15%向上
   - 社内最高売上マネージャーとして2年連続表彰（年間売上3.2億円達成）
   - 4名の新人育成を担当し、全員を1年以内に独立担当としてアサイン
  ○ 使用した技術・ツール：
   - Google広告、Yahoo!広告、Facebook広告、YouTube広告
   - Google Analytics、ADPLAN、Adjust、Google Tag Manager
   - マーケティングオートメーションツール連携

・株式会社Algomaticアドテクノロジー（2010年4月〜2013年4月）
  ○ 会社概要：従業員数約30名、アドテクノロジー企業
  ○ 職務内容：広告運用スペシャリスト
   - リスティング広告専門の運用担当として20社以上のアカウント管理
   - キーワード選定、入札戦略、広告文作成、ランディングページ改善提案
   - クライアント向け月次レポーティングと改善提案の実施
  ○ 具体的な成果：
   - リテール業界クライアントの年間広告費ROI向上（120%→180%）
   - 広告運用マニュアルの整備と社内トレーニングプログラム開発
   - 検索広告特化型の分析レポートフォーマットを開発し、社内標準として採用
  ○ 使用した技術・ツール：
   - Google AdWords（当時）、Yahoo!リスティング広告（当時）
   - Google Analytics、Excel高度分析

【受賞・表彰歴】
・2022年 Google Premier Partner Awards デジタルマーケティング部門 ファイナリスト
・2021年 株式会社Algomaticデジタルマーケティング MVPアワード受賞
・2019年 日本インタラクティブ広告協会（JIAA）優秀事例表彰
・2017年 株式会社Algomaticメディア 売上貢献賞（2年連続）
・2015年 Google AdWords 認定トレーナー選出

【資格】
・Google 広告認定資格（検索広告、ディスプレイ広告、動画広告、ショッピング広告）2023年更新
・Google アナリティクス個人認定資格（GAIQ）2023年更新
・Meta Blueprint認定（上級）2022年取得
・Twitter Flight School認定 2021年取得
・デジタルマーケティング検定 1級 2019年取得
・Yahoo!プロモーション広告 認定プロフェッショナル 2018年取得

【マネジメント経験】
・広告運用チーム（8名）のマネジメント経験 3年間
・チーム売上目標（年間10億円）の達成と33%超過達成
・新卒〜中堅社員の育成プログラム設計と実施（年間6名程度）
・広告効果測定の社内標準メソッド開発と定着
・クライアント別KPIの設定と進捗管理、リソース最適配分
・チームメンバーの専門性に応じたキャリアパス設計と実践

【語学力】
・英語：ビジネスレベル（TOEIC 845点）
  ○ 海外広告プラットフォームとのミーティング対応
  ○ 英語ドキュメントからの情報収集と社内共有
  ○ グローバル展開するクライアント案件のコミュニケーション
` as const;
